<template>
  <div class="d-flex justify-content-center apiary-list">
    <b-container>
      <b-row>
        <b-col v-if="!loaded && !showError" class="col-12 col-md-6 mb-3">
          <b-card>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner></b-spinner>
            </div>
          </b-card>
        </b-col>
        <b-col v-if="showError" class="col-12 col-md-6 mb-3">
          <b-card>
            <p class="text-center">{{ $t('apiaries.error') }}</p>
          </b-card>
        </b-col>
        <b-col class="col-12 col-md-6 mb-3 position-relative" v-for="(apiary, i) in data" :key="i">
          <b-card>
          <b-link class="d-block" :to="'/apiary/' + apiary.id">
            <h1 class="text-primary font-weight-bold text-center"> {{ apiary.title }}</h1>
          </b-link>
            <div class="text-center">
              {{ $t('apiary.form.zipCode.label') }}: {{ apiary.zipCode }}
            </div>
            <div class="action-row">
              <b-link class="text-body icon-pen" :title="$t('apiary_edit.title')"  @click.prevent="checkNetworkUpdate(apiary.id)"></b-link>
            </div>
            <div class="action-row-delete">
              <apiary-delete :id="apiary.id" @confirmDelete="onClickDelete($event)"></apiary-delete>
            </div>
          </b-card>
        </b-col>
        <b-col class="col-12 col-md-6 mb-3 position-relative">
          <b-link class="text-body" :title="$t('apiary_create.title')" @click.prevent="checkNetworkCreate">
            <b-card class="new h-100">
              <div class="h-100 d-flex flex-column justify-content-around">
                <h2 class="text-center mb-0">
                  {{ $t('apiary_create.title') }}
                  <span class="icon-add_filled align-middle" aria-hidden="true"></span>
                </h2>
              </div>
            </b-card>
          </b-link>
        </b-col>
      </b-row>
      <b-modal :id="'offLineModal'" centered hide-header-close @ok="hideModal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import ApiaryDelete from '../components/ApiaryDelete'
import _ from 'lodash'
export default {
  name: 'ApiaryList',
  components: { ApiaryDelete },
  data () {
    return {
      showError: false,
      data: null,
      deleteClicked: null
    }
  },
  computed: {
    loaded () {
      return this.data !== null
    }
  },
  methods: {
    checkNetworkUpdate (id) {
      if (navigator.onLine) {
        this.$router.replace('/apiary/edit/' + id)
      } else {
        this.showOffLineModal()
      }
    },
    checkNetworkCreate () {
      if (navigator.onLine) {
        this.$router.replace('/apiary/create')
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModal')
    },
    hideModal () {
      this.$bvModal.hide('offLineModal')
    },
    async loadData () {
      let result
      try {
        result = await this.$api.apiaries.getAll()
        if (Array.isArray(result)) {
          this.data = result
        } else {
          this.data = []
        }
      } catch (e) { // network error etc.
        result = false
      }

      this.showError = !result
      return this.data
    },
    onClickDelete (value) {
      const vm = this
      if (value) {
        const tempData = this.data
        this.data = null
        setTimeout(function () {
          vm.data = _.filter(tempData, function (apiary) {
            return apiary.id !== value
          })
        }, 1000)
      }
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .apiary-list {
    font-family: "Roboto Condensed", sans-serif;

    h2 {
      font-size: 1.5rem;
    }

    .action-row {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.5rem;
      line-height: 1rem;

      > * {
        display: inline-block;
        padding: 0.5rem 0.75rem;

        &:hover {
          text-decoration: none;
          background-color: $secondary-light;
        }
      }
    }

    .new {
      background-color: $secondary-light;
    }
    .link-titel {
      text-decoration: underline;
      font-weight: bold;
    }
    .card-body {
      padding: 1.25rem;
    }
    .card-body h1{
      font-size: 2rem;
      font-family: $font-family-base;
    }
    .action-row-delete {
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 1.5rem;
      line-height: 1rem;

      > * {
        display: inline-block;
        padding: 0.5rem 0.75rem;

        &:hover {
          text-decoration: none;
          background-color: $secondary-light;
        }
      }
    }
  }
</style>
